// extracted by mini-css-extract-plugin
export var addressFields = "_ow-0";
export var animationContainer = "_ow-1";
export var footer = "_ow-2";
export var lineItems = "_ow-3";
export var modalContent = "_ow-4";
export var orderName = "_ow-5";
export var strong = "_ow-6";
export var warning = "_ow-7";